import { useState } from 'react';
import { useHistory, useRouteMatch } from "react-router-dom";
import useAxios from 'axios-hooks';
import DeleteNotificationModal from './DeleteNotification';
import NotificationsTable from "./NotificationsTable";
import {
    Spinner,
    mergeStyleSets,
} from "@fluentui/react";



const NotificationsList = () => {
    const [showModal, setHideDialog] = useState(false);
    const [selectedNotificationId, setSelectedNotificationId] = useState(null);
    const [selectedNotificationTitle, setSelectedNotificationTitle] = useState("");
    const history = useHistory();
    let { url } = useRouteMatch();

    const toggleShowModal = () => {
        setHideDialog((prev) => !prev);
    };

    const styles = mergeStyleSets({
        blueBtn: {
            backgroundColor: '#255fa7',
            backgroundImage: '-webkit-linear-gradient(top, #41badd, #255fa7)',
            width: '120px !important',
            height: '34px',
            lineHeight: '34px',
            display: 'block',
            float: 'right',
            padding: '0 0 4px 0',
            margin: '0 10px 0 0',
            color: '#fff',
            fontSize: '0.875em',
            textAlign: 'center',
            cursor: 'pointer',
            textDecoration: 'none',
            border: '0',
            textShadow: '0 1px rgba(0, 0, 0, 0.15)',
            borderRadius: '3px',
        },
        greenHeader: {
            color: '#08A239',
            marginLeft: '20px',
        },
        successMessage: {
            backgroundColor: '#90EE90',
            fontWeight: 'bold',
        },
        errorMessage: {
            backgroundColor: '#FFCCCC',
            fontWeight: 'bold',
        },
        spinnerContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100px',
        }
    });

    const [{ data: notifications, loading }, refetch] = useAxios("notifications/all-site");

    if (loading)
        return (
            <Spinner className="absolute-center" label="Loading notifications..." />
        );

    return (
        <>
            <h4 className={styles.greenHeader} >Site Notifications Inventory</h4>
            <NotificationsTable
                notifications={notifications}
                setSelectedNotificationId={setSelectedNotificationId}
                selectedNotificationId={selectedNotificationId}
                setSelectedNotificationTitle={setSelectedNotificationTitle}                
                createOnClick={() => history.push(`${url}/edit`)}
                deleteOnClick={(id, title) => {
                    setSelectedNotificationId(id);
                    setSelectedNotificationTitle(title || "");
                    toggleShowModal();
                }}
                editOnClick={(id) => {
                    history.push(`${url}/edit/${id}`);
                }}
                refetch={refetch}
                loading={loading}
            />
            <DeleteNotificationModal
                notificationId={selectedNotificationId}
                notificationTitle={selectedNotificationTitle}
                showModal={showModal}
                toggleShowModal={toggleShowModal}
                onDelete={() => refetch()}
            />
        </>
    );
}

export default NotificationsList;
